module.exports = __webpack_public_path__ + "img/snake.b278e87a.gif";